import MinecraftBlock from './minecraft_block_breaker_block'
import MinecraftModal from './minecraft_block_breaker_modal'
import { MinecraftBlockBreakerInstructions as MinecraftAudio } from '../minecraft_block_breaker_instructions/minecraft_block_breaker_instructions'

class MinecraftBlockBreaker {
  /** A reference to the global MinecraftModal object */
  static modalController

  constructor (element) {
    this.element = element
    this.blockCountSpan = this.element.querySelector('.js-block-count')

    // Needs to happen early to be available to blocks
    if (!MinecraftBlockBreaker.modalController) {
      const modalController = new MinecraftModal()
      MinecraftBlockBreaker.modalController = modalController
      MinecraftBlock.modalController = modalController
    }

    this.breakableBlocks = [...this.element.querySelectorAll('.js-breakable-block')].map(block => new MinecraftBlock(block))

    this.breakableBlocks.forEach(block => {
      if (block.hasItem) {
        MinecraftBlockBreaker.modalController.registerItem(block.element.dataset.itemid)
        block.onBreak = MinecraftBlockBreaker.modalController.openWithData
        block.onClickAfterBreak = MinecraftBlockBreaker.modalController.openWithData
      }

      block.element.addEventListener('click', () => {
        if (block.state !== 'broken') {
          MinecraftAudio.playAudio(block.audioKey)
        }
        block.click()

        const remainingBlockCount = this.breakableBlocks.filter(b => b.state !== 'broken').length
        this.blockCountSpan.innerHTML = remainingBlockCount
      })
    })

    window.addEventListener('resize', () => {
      this.setHalfHeight()
    })

    this.setHalfHeight()
  }

  /**
   * Sets the --half-height CSS variable
   */
  setHalfHeight = () => {
    this.element.style.setProperty('--half-height', `${this.element.getBoundingClientRect().height / 2}px`)
  }
}

export default {
  selector: '.js-minecraft-block-breaker',
  Source: MinecraftBlockBreaker
}
